import canje from './canje'
import carpeta from './carpeta';
import conduce from './conduce';
import cliente from './cliente';
import empleados from './empleados';

const template = {
    canje,
    carpeta,
    conduce,
    cliente,
    empleados
}

export default template;

